export default __webpack_public_path__ + "static/media/2_3.1b2f89f5.jpg";